const moduleKey = "machineOverviewContainer";

export const machineOverviewContainerEn = {
  [moduleKey]: {
    cycles: "Cycles",
    progress: "Progress",
    productionDataset: "Production Dataset",
    moldCatActualDescription: "Order",
    filename: "File",
    customer: "Customer",
    material: "Material",
    lastUpdated: "Last updated",
    noDataAvailable: "No machine data available for the past 30 minutes.",
    mode: {
      off: "Off",
      manual: "Manual",
      setup: "Setup",
      semiAutomatic: "Semi Automatic",
      automatic: "Automatic",
      service: "Service",
      sleep: "Sleep",
      other: "Other",
    },
  },
};

export const machineOverviewContainerPtBr = {
  [moduleKey]: {
    cycles: "Ciclos",
    progress: "Progresso",
    productionDataset: "Conjunto de dados de producao",
    moldCatActualDescription: "Ordem",
    filename: "Arquivo",
    customer: "Cliente",
    material: "Material",
    lastUpdated: "Ultima atualizacao",
    noDataAvailable: "Sem dados de maquina disponiveis nos ultimos 30 minutos",
    mode: {
      off: "Desligado",
      manual: "Manual",
      setup: "Configuracao",
      semiAutomatic: "Semiautomatico",
      automatic: "Automatico",
      service: "Servico",
      sleep: "Dormir",
      other: "Outro",
    },
  },
};

export const machineOverviewContainerDe = {
  [moduleKey]: {
    cycles: "Zyklen",
    progress: "Fortschritt",
    productionDataset: "Produktionsdatensatz",
    moldCatActualDescription: "Auftrag",
    filename: "Datei",
    customer: "Kunde",
    material: "Material",
    lastUpdated: "Zuletzt aktualisiert",
    noDataAvailable: "Keine Maschinendaten in den letzten 30 Minuten verfügbar",
    mode: {
      off: "Aus",
      manual: "Manuell",
      setup: "Einrichtung",
      semiAutomatic: "Halbautomatisch",
      automatic: "Automatisch",
      service: "Service",
      sleep: "Schlafen",
      other: "Andere",
    },
  },
};

export const machineOverviewContainerZhHans = {
  [moduleKey]: {
    cycles: "周期",
    progress: "进度",
    productionDataset: "生产数据集",
    moldCatActualDescription: "订单",
    filename: "文件",
    customer: "客户",
    material: "材料",
    lastUpdated: "最后更新",
    noDataAvailable: "过去30分钟内此机器暂无可用数据",
    mode: {
      off: "关闭",
      manual: "手动",
      setup: "设置",
      semiAutomatic: "半自动",
      automatic: "自动",
      service: "服务",
      sleep: "睡眠",
      other: "其他",
    },
  },
};

export const machineOverviewContainerIt = {
  [moduleKey]: {
    cycles: "Cicli",
    progress: "Progresso",
    productionDataset: "Dataset di produzione",
    moldCatActualDescription: "Ordine",
    filename: "File",
    customer: "Cliente",
    material: "Materiale",
    lastUpdated: "Ultimo aggiornamento",
    noDataAvailable:
      "Nessun dato disponibile per questa macchina negli ultimi 30 minuti",
    mode: {
      off: "Spento",
      manual: "Manuale",
      setup: "Configurazione",
      semiAutomatic: "Semiautomatico",
      automatic: "Automatico",
      service: "Servizio",
      sleep: "Sospensione",
      other: "Altro",
    },
  },
};

export const machineOverviewContainerEs = {
  [moduleKey]: {
    cycles: "Ciclos",
    progress: "Progreso",
    productionDataset: "Conjunto de datos de produccion",
    moldCatActualDescription: "Orden",
    filename: "Archivo",
    customer: "Cliente",
    material: "Material",
    lastUpdated: "Ultima actualizacion",
    noDataAvailable:
      "No hay datos de maquina disponibles en los ultimos 30 minutos",
    mode: {
      off: "Apagado",
      manual: "Manual",
      setup: "Configuracion",
      semiAutomatic: "Semiautomatico",
      automatic: "Automatico",
      service: "Servicio",
      sleep: "Dormir",
      other: "Otro",
    },
  },
};

export const machineOverviewContainerNl = {
  [moduleKey]: {
    cycles: "Cycli",
    progress: "Voortgang",
    productionDataset: "Productiedataset",
    moldCatActualDescription: "Order",
    filename: "Bestand",
    customer: "Klant",
    material: "Materiaal",
    lastUpdated: "Laatst bijgewerkt",
    noDataAvailable:
      "Geen machinegegevens beschikbaar voor de afgelopen 30 minuten.",
    mode: {
      off: "Uit",
      manual: "Handmatig",
      setup: "Instellen",
      semiAutomatic: "Semi-automatisch",
      automatic: "Automatisch",
      service: "Service",
      sleep: "Slaap",
      other: "Andere",
    },
  },
};

export const machineOverviewContainerTr = {
  [moduleKey]: {
    mode: {
      automatic: "Otomatik",
      manual: "Manuel",
      off: "Kapalı",
      other: "Diğer",
      semiAutomatic: "Yarı Otomatik",
      service: "Hizmet",
      setup: "Kurmak",
      sleep: "Uyumak",
    },
    customer: "Müşteri",
    cycles: "Döngüler",
    filename: "Dosya adı",
    lastUpdated: "Son güncelleme",
    material: "Malzeme",
    moldCatActualDescription: "Emir",
    noDataAvailable: "Son 30 dakikaya ait makine verisi yok.",
    productionDataset: "Üretim Veri Kümesi",
    progress: "İlerlemek",
  },
};
